[
  {
    "description": "#Capstone #인턴십 #개인프로젝트 #Technovation대회",
    "image": "cherry.jpg",
    "videoId": "jStDzvI6aOE"
  },
  {
    "description": "#Capstone #인턴십 #ProjectXR #VR",
    "image": "chris.jpg",
    "videoId": "xw7dw44Sjqo"
  },
  {
    "description": "#VEXIQ #WorldChampionship #SkillsChallenge1위",
    "image": "mangotango.png",
    "videoId": "j_lJDuIeIyM"
  },
  {
    "description": "#한국1위 #Technovation24",
    "image": "techno24.png",
    "videoId": "CLiDvldBYjs"
  },
  {
    "description": "#Technovation25수상 #한국유일본선진출 #TeamVera",
    "image": "techno25.jpg",
    "videoId": "_TZCvTOzTHM"
  }
]
